import script from "./ChangeSceneCom.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeSceneCom.vue?vue&type=script&setup=true&lang=js"

import "./ChangeSceneCom.vue?vue&type=style&index=0&id=40e6d9aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40e6d9aa"]])

export default __exports__